import { apiService } from "./api";

export interface DeliveryService {
    delivery_service_id: string;
    name: string;
    type: "INHOUSE" | "THIRD_PARTY";
    contact_phone?: string;
    contact_email?: string;
    tracking_url_template?: string;
    label_url_template?: string;
    // Numeric Telegram chat id — required to DM this courier (see
    // DeliveryServiceManagement's helper text for how to obtain it).
    tg_chat_id?: string;
    // Human-readable label only; never used to address a send.
    tg_username?: string;
    is_active: boolean;
    created_at: string;
}

export interface DeliveryServiceSimple {
    delivery_service_id: string;
    name: string;
    type: string;
    tracking_url_template?: string;
    label_url_template?: string;
    tg_chat_id?: string;
}

export const deliveryService = {
    async getDeliveryServices(
        activeOnly: boolean = true,
    ): Promise<DeliveryService[]> {
        return apiService.get<DeliveryService[]>(
            `/delivery-services/?active_only=${activeOnly}`,
        );
    },

    async getDeliveryServicesSimple(
        activeOnly: boolean = true,
    ): Promise<DeliveryServiceSimple[]> {
        return apiService.get<DeliveryServiceSimple[]>(
            `/delivery-services/simple?active_only=${activeOnly}`,
        );
    },

    async getDeliveryService(id: string): Promise<DeliveryService> {
        return apiService.get<DeliveryService>(`/delivery-services/${id}`);
    },

    async createDeliveryService(
        data: Omit<DeliveryService, "delivery_service_id" | "created_at">,
    ): Promise<DeliveryService> {
        return apiService.post<DeliveryService>("/delivery-services/", data);
    },

    async updateDeliveryService(
        id: string,
        data: Partial<DeliveryService>,
    ): Promise<DeliveryService> {
        return apiService.put<DeliveryService>(
            `/delivery-services/${id}`,
            data,
        );
    },

    async deleteDeliveryService(id: string): Promise<void> {
        return apiService.delete<void>(`/delivery-services/${id}`);
    },
};
